import React from "react";
import {
  FileUploadContainer,
  FormField,
  DragDropText,
  ImagePreview,
  PreviewContainer,
  FileMetaData,
  ContentDragAndDrop,
  NameFileUpload,
} from "./FileUpload.styled";
import CloseIcon from "@material-ui/icons/Close";
import PublishIcon from "@material-ui/icons/Publish";
import { ReactComponent as GreyUIPublishIcon } from "../../assets/svg/greyui-publish-icon.svg";
import { NotificationManager } from "react-notifications";
import ModalLoader from "../ModalLoader/ModalLoader";
import * as XLSX from "xlsx";

const KILO_BYTES_PER_BYTE = 1000;
const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 7340032;

const convertBytesToKB = (bytes) => Math.round(bytes / KILO_BYTES_PER_BYTE);

const FileUpload = ({
  accept,
  label,
  updateFilesCb,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  setDataBulkUpload,
  setFiles,
  files,
  loadingImage = false,
  greyUI = false,
  maxWidth,
  ...otherProps
}) => {
  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        if (!otherProps.multiple) {
          return { file };
        }
        files[file.name] = file;
      }
    }
    return { ...files };
  };

  const handleNewFileUpload = (e) => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let extension = newFiles[0].name.substr(
        newFiles[0].name.lastIndexOf(".")
      );
      accept.split(",").findIndex((f) => f === extension);
      if (accept.split(",").findIndex((f) => f === extension) > -1) {
        let updatedFiles = addNewFiles(newFiles);
        if (updatedFiles.file) {
          setFiles(updatedFiles);
          let reader = new FileReader();
          reader.onload = function (evt) {
            if (accept === ".xlsx") {
              let workbook = XLSX.read(evt.target.result, {
                type: "binary",
              });
              let allData = [];
              workbook.SheetNames.forEach(function (sheetName) {
                // Here is your object
                let XL_row_object = XLSX.utils.sheet_to_row_object_array(
                  workbook.Sheets[sheetName]
                );
                let json_object = JSON.stringify(XL_row_object);
                if (json_object) {
                  allData.push(json_object);
                }
              });
              setDataBulkUpload(allData);
            } else {
              setDataBulkUpload(evt.target.result.split("\n"));
            }
          };
          reader.onerror = function (ex) {
            console.log("ex", ex);
          };
          if (accept === ".xlsx") {
            reader.readAsBinaryString(updatedFiles.file);
          } else {
            reader.readAsText(updatedFiles.file);
          }
        } else {
          NotificationManager.warning(
            "File size exceeds allowed size",
            "",
            5000
          );
        }
      } else {
        NotificationManager.warning("Format not allowed", "", 5000);
      }
    }
  };

  const removeFile = (fileName) => {
    delete files[fileName];
    setFiles({ ...files });
  };

  return (
    <>
      <div>
        {loadingImage && <ModalLoader></ModalLoader>}
        {!loadingImage &&
          files?.file === undefined &&
          /^image\/+[A-Z]+$/i.test(files?.file?.type) === false && (
            <FileUploadContainer greyUI={greyUI} loaded={files.file}>
              <ContentDragAndDrop greyUI={greyUI} loaded={files.file}>
                {/* <InputLabel>{label}</InputLabel> */}
                {!greyUI && (
                  <>
                    <PublishIcon />
                    <DragDropText>Drag and drop your files here</DragDropText>
                  </>
                )}
                {greyUI && (
                  <div className="greyUI">
                    <GreyUIPublishIcon />
                    <DragDropText>Drag and drop your files here</DragDropText>
                    <label className="link-label">
                      click here to upload your image
                    </label>
                  </div>
                )}
                {/* <UploadFileBtn type="button" onClick={handleUploadBtnClick}>
          <i className="fas fa-file-upload" />
          <span> Upload {otherProps.multiple ? "files" : "a file"}</span>
        </UploadFileBtn> */}
                <FormField
                  type="file"
                  // ref={fileInputField}
                  onChange={handleNewFileUpload}
                  title=""
                  value=""
                  {...otherProps}
                />
              </ContentDragAndDrop>
            </FileUploadContainer>
          )}
        {files &&
          files.file &&
          /^image\/+[A-Z]+$/i.test(files.file.type) === false && (
            <>
              <NameFileUpload>
                <div>
                  {files.file.name} {files.file.size} bytes
                </div>
              </NameFileUpload>
            </>
          )}
      </div>
      {files.file && /^image\/+[A-Z]+$/i.test(files.file.type) && (
        <>
          {/* <span>To Upload</span> */}
          {/* <PreviewList> */}
          {Object.keys(files).map((fileName, index) => {
            let file = files[fileName];
            let isImageFile = file.type.split("/")[0] === "image";
            return (
              <PreviewContainer maxWidth={maxWidth} key={fileName}>
                <div>
                  {isImageFile && (
                    <ImagePreview
                      src={URL.createObjectURL(file)}
                      alt={`file preview ${index}`}
                    />
                  )}
                  <FileMetaData isImageFile={isImageFile}>
                    <span>{file.name}</span>
                    <aside>
                      <span>{convertBytesToKB(file.size)} kb</span>
                      <span>{file.size} bytes</span>
                      <CloseIcon
                        style={{ cursor: "pointer" }}
                        className="fas fa-trash-alt"
                        onClick={() => removeFile(fileName)}
                      />
                    </aside>
                  </FileMetaData>
                </div>
              </PreviewContainer>
            );
          })}
          {/* </PreviewList> */}
        </>
      )}
    </>
  );
};

export default FileUpload;
